import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { FileText, Mail } from "lucide-react";
import ReportModal from "@/components/ReportModal";

export default function Reports() {
    const [plants, setPlants] = useState([]);
    const [history, setHistory] = useState([]);
    const [reportFor, setReportFor] = useState(null);

    useEffect(() => {
        api.get("/plants").then(r => setPlants(r.data));
        api.get("/reports/history").then(r => setHistory(r.data));
    }, [reportFor]);

    return (
        <div className="space-y-6" data-testid="reports-page">
            <div>
                <div className="text-[10px] font-semibold uppercase tracking-[0.18em] text-zinc-500">Executive</div>
                <h1 className="text-4xl sm:text-5xl font-semibold tracking-tight text-zinc-900 mt-1">Customer Reports</h1>
                <p className="text-sm text-zinc-500 mt-1">Preview and email performance reports to any customer.</p>
            </div>

            <div className="bg-white border border-zinc-200 rounded-2xl">
                <div className="p-5 border-b border-zinc-100">
                    <div className="text-[10px] font-semibold uppercase tracking-[0.18em] text-zinc-500">Select Plant</div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 p-5">
                    {plants.map((p, i) => (
                        <div key={p.id} className="border border-zinc-200 rounded-2xl p-5 hover:border-[#0A0A0A] transition-colors duration-200" data-testid={`report-plant-card-${i}`}>
                            <Link to={`/plants/${p.id}`} className="text-sm font-semibold text-zinc-900 hover:text-black block truncate">{p.customer_name || p.name}</Link>
                            {p.customer_name && p.location && (
                                <div className="text-[10px] font-mono text-zinc-500 mt-0.5 truncate">{p.location} · {p.name}</div>
                            )}
                            <div className="text-xs text-zinc-500 mt-0.5 truncate">{p.owner_name}</div>
                            <div className="flex items-center justify-between mt-4">
                                <span className="text-xs font-mono text-zinc-600">{p.installed_capacity_kw} kWp</span>
                                <Button size="sm" onClick={() => setReportFor(p)} className="bg-[#0A0A0A] hover:bg-black text-white rounded-full h-8 px-3 text-xs font-semibold" data-testid={`open-report-btn-${i}`}>
                                    <FileText className="w-3 h-3 mr-1" /> Report
                                </Button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {history.length > 0 && (
                <div className="bg-white border border-zinc-200 rounded-2xl">
                    <div className="p-5 border-b border-zinc-100">
                        <div className="text-[10px] font-semibold uppercase tracking-[0.18em] text-zinc-500">Sent Reports History</div>
                    </div>
                    <div className="overflow-x-auto">
                    <table className="w-full text-sm min-w-[720px]">
                        <thead>
                            <tr className="text-[10px] uppercase tracking-wider text-zinc-500 bg-zinc-50 border-b border-zinc-200">
                                <th className="py-2.5 px-4 text-left font-semibold">Sent</th>
                                <th className="py-2.5 px-4 text-left font-semibold">To</th>
                                <th className="py-2.5 px-4 text-left font-semibold">Subject</th>
                                <th className="py-2.5 px-4 text-left font-semibold">By</th>
                                <th className="py-2.5 px-4 text-left font-semibold">Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {history.map((h, i) => (
                                <tr key={i} className="border-b border-zinc-100" data-testid={`history-row-${i}`}>
                                    <td className="py-2.5 px-4 font-mono text-xs text-zinc-600">{h.sent_at?.slice(0, 16).replace('T', ' ')}</td>
                                    <td className="py-2.5 px-4 text-zinc-700"><Mail className="w-3 h-3 inline mr-1.5 text-[#16A34A]" />{h.to_email}</td>
                                    <td className="py-2.5 px-4 text-zinc-600 max-w-md truncate">{h.subject}</td>
                                    <td className="py-2.5 px-4 text-zinc-600">{h.sent_by}</td>
                                    <td className={`py-2.5 px-4 text-xs font-mono ${h.status === "sent" ? "text-[#16A34A]" : h.status === "failed" ? "text-red-600" : "text-zinc-600"}`}>{h.status}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    </div>
                </div>
            )}

            {reportFor && <ReportModal stationId={reportFor.id} ownerEmail={reportFor.owner_email} plantName={reportFor.customer_name || reportFor.name} onClose={() => setReportFor(null)} />}
        </div>
    );
}
